module.exports = __webpack_public_path__ + "assets/img/eig.a15d7c92.png";